<script lang="ts">
  import ProductResponse from "../../Conversation/ProductResponse.svelte";

  export let s;
  export let log;
  export let overrideStyleRow =
    "justify-content: flex-start; margin-left: 7px;";
</script>

<div class={s.productResponse}>
  <ProductResponse {log} {overrideStyleRow} />
</div>
